// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__ChUfw","fadeInOut":"styles_fadeInOut__U30pP","loader":"styles_loader__LfrKv"};